<template>
    <div class="animated fadeIn">
        <v-server-table :url="apiurl('voucher/table/fu')"  :columns="columns" :options="options" :theme="theme" id="vouchersTable" ref="vouchersTable" >
        </v-server-table>
    </div>
</template>

<script>
    import Vue from 'vue'
    //import {ServerTable, Event} from 'vue-tables-2'
    //import { functions } from '@/functions.js';
    //Vue.use(ServerTable)
    import {CONSTANTS} from '@/constants';

    export default {
        name: 'CompanyProfile',
        //components: { ServerTable, Event },
        mixins: [functions],
        data: function () {
            return {
                //saveState: true,
            }
        },
        methods: {

        },
        computed: {

        },
        created: function() {
            Event.$on('vue-tables.loading', ()=>{ /* this.$eventHub.$emit('loading_start'); */ });
            Event.$on('vue-tables.loaded',()=>{ /*this.$eventHub.$emit('loading_end'); */ });
        }
    }
</script>
